import { useMutation } from '@tanstack/react-query';
import { trackError } from '@proposify/frontend-observability';
import { useTranslation } from 'react-i18next';
import { openNotification } from 'components/notification';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { useInvalidateApprovalQueries } from 'hooks/useInvalidateApprovalQueries';

type RequestApprovalMutationVariables = {
  contentId: string;
  comment?: string;
};

export const useRequestApprovalMutation = () => {
  const { t } = useTranslation();
  const invalidateApprovalQueries = useInvalidateApprovalQueries('useRequestApprovalMutation');

  return useMutation<void, unknown, RequestApprovalMutationVariables>({
    mutationFn: async ({ contentId, comment }) => {
      try {
        await apiDocumentServiceRepository.requestApproval(contentId, { comment });
      } catch (error) {
        trackError(error, { tags: { module: 'useRequestApprovalMutation' }, extra: { contentId } });
        throw error;
      }
    },
    onSuccess: (_data, { contentId }) => {
      void invalidateApprovalQueries(contentId);
      openNotification({ type: 'success', title: t('share_document_v3.request_approval_menu.success') });
    },
    onError: () => {
      openNotification({ type: 'error', title: t('share_document_v3.request_approval_menu.error') });
    },
  });
};
